var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemplateImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#2E3A59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4618_74488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7778 26H8.22222C6.99492 26 6 25.0051 6 23.7778V8.22222C6 6.99492 6.99492 6 8.22222 6H23.7778C25.0051 6 26 6.99492 26 8.22222V23.7778C26 25.0051 25.0051 26 23.7778 26ZM8.22222 8.22222V23.7778H23.7778V8.22222H8.22222ZM22.6667 21.5556H9.33333L12.6667 17.1111L13.7778 18.2222L17.1111 13.7778L22.6667 21.5556ZM12.1111 14.8889C11.1906 14.8889 10.4444 14.1427 10.4444 13.2222C10.4444 12.3017 11.1906 11.5556 12.1111 11.5556C13.0316 11.5556 13.7778 12.3017 13.7778 13.2222C13.7778 14.1427 13.0316 14.8889 12.1111 14.8889Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4618_74488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "transparent"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateImage);
export default __webpack_public_path__ + "static/media/template-image.d5be4e9d.svg";
export { ForwardRef as ReactComponent };